export const AuthenticationProvider = {
  None: 0,
  PosViaTouchTab: 1,
  TouchTab: 2,
  PosDirect: 3,
} as const;

export type AuthenticationProvider = (typeof AuthenticationProvider)[keyof typeof AuthenticationProvider];
